/* Timbrica — /elevation. Высота над уровнем моря, профиль и уклон.
 *
 * ПОЧЕМУ ЭТОТ ТУЛ
 * ---------------
 * «Высота над уровнем моря» — 106 888 показов/мес, «рельеф местности» — 9 073,
 * «мои координаты» — 4 643. Выдача занята мелочью без бренда: a-102.ru,
 * elevationmap.ru, mapatlas, maplogs, glandnav. Все они отвечают ОДНИМ числом
 * в точке и на этом заканчиваются.
 *
 * ЧЕМ ОТЛИЧАЕМСЯ
 *   1. ПРОФИЛЬ ПО ЛИНИИ, а не одна точка: набор и сброс высоты, максимальный
 *      и средний уклон в процентах И в градусах. Это то, что реально нужно
 *      велосипедисту, туристу и тому, кто ставит забор на склоне.
 *   2. ЧЕСТНО ПРО ТОЧНОСТЬ. Данные — модель РЕЛЬЕФА с шагом ~30 м: дома,
 *      мосты и деревья в неё не входят, а ошибка по высоте — несколько метров.
 *      Ни один конкурент этого не пишет, и человек считает число абсолютным.
 *   3. РАСЧЁТ В БРАУЗЕРЕ. Высота читается прямо из пикселя плитки рельефа
 *      (Terrarium, AWS Open Data, public domain) — наш сервер не участвует,
 *      поэтому нет ни очереди, ни лимита на число точек.
 *   4. КООРДИНАТЫ В ДВУХ ФОРМАТАХ рядом с высотой — их ищут тем же запросом.
 */
(function () {
  'use strict';

  var C = window.ELEV_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };

  var TILE_Z = 12;                 // компромисс: шаг ~38 м на экваторе, мало плиток
  var tileCache = {};              // ключ z/x/y → ImageData или 'fail'
  var pending = {};

  var state = {
    map: null, marker: null, line: null, pts: [], mode: 'point'
  };
  /* Leaflet, bound ONCE when the map is built (initMap). Every later call used
     the global `L` afresh, and an in-app browser (TECNO, Chrome WebView 151,
     session flagged in-app) replaced window.L with its own object after our
     map was up: the map still answered clicks, but `L.circleMarker` and
     `L.polyline` were «not a function» (Sentry TIMBRICA-FRONTEND-K6/K7,
     13.09.2026). A dependency taken at init cannot be swapped under us. */
  var Lf = null;

  // ── Плитки рельефа ──────────────────────────────────────────────────────────

  /**
   * Адрес плитки рельефа. C.terrain — СПИСОК по приоритету: для ru первым идёт
   * наш прокси, для остальных прямой AWS. Это не подложка, а сами ДАННЫЕ тула:
   * недоступен хост — высоты нет вовсе. Раньше здесь стоял один адрес на
   * s3.amazonaws.com без всякой запасной дороги.
   */
  var terrainIdx = 0;
  function terrainList() {
    return (C.terrain && C.terrain.length) ? C.terrain : [String(C.terrain || '')];
  }
  function tileUrl(z, x, y, idx) {
    var list = terrainList();
    var tpl = list[Math.min(idx == null ? terrainIdx : idx, list.length - 1)] || '';
    return tpl.replace('{z}', z).replace('{x}', x).replace('{y}', y);
  }

  function lonToTileX(lon, z) { return (lon + 180) / 360 * Math.pow(2, z); }
  function latToTileY(lat, z) {
    var r = lat * Math.PI / 180;
    return (1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * Math.pow(2, z);
  }

  /**
   * Высота в точке. Плитка Terrarium кодирует метры в цвете:
   *   h = R*256 + G + B/256 − 32768
   * Читаем пиксель, поэтому нужен crossOrigin — без него канва «пачкается»
   * и getImageData бросает SecurityError.
   */
  function elevationAt(lat, lon) {
    return new Promise(function (resolve) {
      var z = TILE_Z;
      var fx = lonToTileX(lon, z), fy = latToTileY(lat, z);
      var tx = Math.floor(fx), ty = Math.floor(fy);
      var key = z + '/' + tx + '/' + ty;

      function sample(img) {
        if (img === 'fail') { resolve(null); return; }
        var px = Math.min(255, Math.max(0, Math.floor((fx - tx) * 256)));
        var py = Math.min(255, Math.max(0, Math.floor((fy - ty) * 256)));
        var i = (py * 256 + px) * 4;
        var h = img.data[i] * 256 + img.data[i + 1] + img.data[i + 2] / 256 - 32768;
        resolve(h);
      }

      if (tileCache[key]) { sample(tileCache[key]); return; }
      if (pending[key]) { pending[key].push(sample); return; }
      pending[key] = [sample];

      /* Пробуем адреса по порядку. Первый отказ — НЕ приговор: у рельефа есть
         второй источник, и переключиться надо молча для человека, но громко
         для телеметрии. Раньше отказ первого адреса был отказом тула. */
      function attempt(idx) {
        var list = terrainList();
        if (idx >= list.length) {
          tileCache[key] = 'fail';
          var qf = pending[key]; delete pending[key];
          qf.forEach(function (fn) { fn('fail'); });
          ae('tool_diagnostic', { slug: 'elevation', issue: 'terrain_tile_failed', tried: list.length });
          return;
        }
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var cv = document.createElement('canvas');
            cv.width = 256; cv.height = 256;
            var g = cv.getContext('2d', { willReadFrequently: true });
            g.drawImage(im, 0, 0);
            tileCache[key] = g.getImageData(0, 0, 256, 256);
          } catch (e) { tileCache[key] = 'fail'; }
          if (idx > terrainIdx) {
            // Запомним рабочий источник, чтобы следующие плитки шли сразу туда.
            terrainIdx = idx;
            ae('asset_fallback', { slug: 'elevation', asset: 'terrain', index: idx });
          }
          var q = pending[key]; delete pending[key];
          q.forEach(function (fn) { fn(tileCache[key]); });
        };
        im.onerror = function () { attempt(idx + 1); };
        im.src = tileUrl(z, tx, ty, idx);
      }
      attempt(terrainIdx);
    });
  }

  // ── Форматирование ──────────────────────────────────────────────────────────

  function fmt(x, d) {
    try { return Number(x).toLocaleString(C.locale, { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    catch (e) { return Number(x).toFixed(d || 0); }
  }
  /** Градусы-минуты-секунды — второй формат, которым люди пользуются. */
  function toDms(v, posChar, negChar) {
    var sign = v < 0 ? negChar : posChar;
    v = Math.abs(v);
    var d = Math.floor(v), m = Math.floor((v - d) * 60), s = ((v - d) * 60 - m) * 60;
    return d + '°' + String(m).padStart(2, '0') + '′' + fmt(s, 1) + '″ ' + sign;
  }
  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }

  function haversineM(a, b) {
    var R = 6371008.8, p = Math.PI / 180;
    var dLat = (b[0] - a[0]) * p, dLon = (b[1] - a[1]) * p;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a[0] * p) * Math.cos(b[0] * p) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  // ── Точка ───────────────────────────────────────────────────────────────────

  /* Ответ выдан — высота или профиль ПОКАЗАНЫ. Два режима считаем отдельно:
     точка и маршрут — разные задачи, и доходимость у них разная. Каждый режим
     засчитывается один раз: дальше человек кликает по карте сколько хочет, это
     feature_use, а не новые завершения. */
  var answered = { point: false, profile: false };
  function markAnswered(kind, extra) {
    if (answered[kind]) return;
    answered[kind] = true;
    stage('complete');
    var p = { slug: 'elevation', mode: kind };
    if (extra) for (var k in extra) p[k] = extra[k];
    ae('tool_complete', p);
  }

  function showPoint(lat, lon) {
    if (!Lf || !state.map) return;
    setText('elLat', fmt(lat, 6));
    setText('elLon', fmt(lon, 6));
    setText('elDms', toDms(lat, tr('n'), tr('s')) + '  ' + toDms(lon, tr('e'), tr('w')));
    setText('elAlt', '…');
    elevationAt(lat, lon).then(function (h) {
      if (h == null) {
        setText('elAlt', tr('no_data'));
        // «Нет данных» — это НЕ ответ. Раньше этот случай был неотличим от
        // успеха: воронка заканчивалась на 'ready' у всех одинаково.
        ae('tool_diagnostic', { slug: 'elevation', issue: 'no_elevation_for_point' });
        return;
      }
      setText('elAlt', fmt(h, 0) + ' ' + tr('m'));
      setText('elFeet', fmt(h * 3.28084, 0) + ' ' + tr('ft'));
      markAnswered('point', { meters: Math.round(h) });
    });
    if (state.marker) state.map.removeLayer(state.marker);
    state.marker = Lf.circleMarker([lat, lon], { radius: 7, color: SKIN[skin].pin, weight: 2, fillColor: SKIN[skin].pin, fillOpacity: .8 }).addTo(state.map);
  }

  // ── Профиль ─────────────────────────────────────────────────────────────────

  function addProfilePoint(lat, lon) {
    if (!Lf || !state.map) return;
    state.pts.push([lat, lon]);
    if (state.line) state.map.removeLayer(state.line);
    state.line = Lf.polyline(state.pts, { color: SKIN[skin].line, weight: 4, opacity: .9 }).addTo(state.map);
    if (state.pts.length >= 2) buildProfile();
    setText('elPtCount', String(state.pts.length));
  }

  function buildProfile() {
    // Сэмплируем по 120 точек на весь маршрут — этого хватает на график и на
    // статистику, и при этом плиток скачивается немного.
    var total = 0, segs = [];
    for (var i = 1; i < state.pts.length; i++) {
      var d = haversineM(state.pts[i - 1], state.pts[i]);
      segs.push(d); total += d;
    }
    if (!total) return;
    var N = 120, samples = [];
    for (var k = 0; k <= N; k++) {
      var target = total * k / N, acc = 0, idx = 0;
      while (idx < segs.length && acc + segs[idx] < target) { acc += segs[idx]; idx++; }
      var t = segs[idx] ? (target - acc) / segs[idx] : 0;
      var a = state.pts[idx], b = state.pts[Math.min(idx + 1, state.pts.length - 1)];
      samples.push({ dist: target, lat: a[0] + (b[0] - a[0]) * t, lon: a[1] + (b[1] - a[1]) * t });
    }
    setText('elProfState', tr('loading_profile'));
    Promise.all(samples.map(function (s) { return elevationAt(s.lat, s.lon); })).then(function (hs) {
      var pts = [];
      for (var i = 0; i < hs.length; i++) if (hs[i] != null) pts.push({ d: samples[i].dist, h: hs[i] });
      if (pts.length < 2) {
        setText('elProfState', tr('no_data'));
        ae('tool_diagnostic', { slug: 'elevation', issue: 'profile_no_data', asked: samples.length });
        return;
      }
      setText('elProfState', '');
      drawProfile(pts, total);
      markAnswered('profile', { points: state.pts.length, km: Math.round(total / 100) / 10 });
    });
  }

  function drawProfile(pts, totalM) {
    var up = 0, down = 0, maxSlope = 0;
    for (var i = 1; i < pts.length; i++) {
      var dh = pts[i].h - pts[i - 1].h, dd = pts[i].d - pts[i - 1].d;
      if (dh > 0) up += dh; else down -= dh;
      if (dd > 1) maxSlope = Math.max(maxSlope, Math.abs(dh / dd));
    }
    var hs = pts.map(function (p) { return p.h; });
    var lo = Math.min.apply(null, hs), hi = Math.max.apply(null, hs);
    var avgSlope = totalM > 1 ? Math.abs(pts[pts.length - 1].h - pts[0].h) / totalM : 0;

    setText('elDist', totalM >= 1000 ? fmt(totalM / 1000, 2) + ' ' + tr('km') : fmt(totalM, 0) + ' ' + tr('m'));
    setText('elUp', '+' + fmt(up, 0) + ' ' + tr('m'));
    setText('elDown', '−' + fmt(down, 0) + ' ' + tr('m'));
    setText('elMinMax', fmt(lo, 0) + ' … ' + fmt(hi, 0) + ' ' + tr('m'));
    // Уклон и в процентах, и в градусах: дорожники считают в процентах,
    // а «сколько градусов» спрашивают все остальные.
    setText('elMaxSlope', fmt(maxSlope * 100, 1) + '% · ' + fmt(Math.atan(maxSlope) * 180 / Math.PI, 1) + '°');
    setText('elAvgSlope', fmt(avgSlope * 100, 1) + '% · ' + fmt(Math.atan(avgSlope) * 180 / Math.PI, 1) + '°');

    var cv = $('elChart');
    if (!cv) return;
    var w = cv.clientWidth || 600, h = 160, dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = w * dpr; cv.height = h * dpr;
    cv.style.height = h + 'px';
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);

    var pad = 6, span = Math.max(1, hi - lo);
    var X = function (d) { return pad + (d / totalM) * (w - pad * 2); };
    var Y = function (v) { return h - pad - ((v - lo) / span) * (h - pad * 2); };

    g.beginPath();
    g.moveTo(X(pts[0].d), h - pad);
    pts.forEach(function (p) { g.lineTo(X(p.d), Y(p.h)); });
    g.lineTo(X(pts[pts.length - 1].d), h - pad);
    g.closePath();
    var grad = g.createLinearGradient(0, 0, 0, h);
    grad.addColorStop(0, 'rgba(255,156,74,.35)');
    grad.addColorStop(1, 'rgba(255,156,74,.02)');
    g.fillStyle = grad; g.fill();

    g.beginPath();
    pts.forEach(function (p, i) { i ? g.lineTo(X(p.d), Y(p.h)) : g.moveTo(X(p.d), Y(p.h)); });
    g.strokeStyle = '#ff9c4a'; g.lineWidth = 2; g.stroke();
  }

  function clearProfile() {
    state.pts = [];
    if (state.line) { state.map.removeLayer(state.line); state.line = null; }
    setText('elPtCount', '0');
    ['elDist', 'elUp', 'elDown', 'elMinMax', 'elMaxSlope', 'elAvgSlope'].forEach(function (id) { setText(id, '—'); });
    var cv = $('elChart');
    if (cv) { var g = cv.getContext('2d'); g.clearRect(0, 0, cv.width, cv.height); }
  }

  // ── Карта и режимы ──────────────────────────────────────────────────────────

  function setMode(m) {
    state.mode = m;
    var a = $('elModePoint'), b = $('elModeProfile');
    if (a) a.classList.toggle('on', m === 'point');
    if (b) b.classList.toggle('on', m === 'profile');
    var pw = $('elProfileWrap');
    if (pw) pw.hidden = m !== 'profile';
    var hint = $('elHint');
    if (hint) hint.textContent = m === 'point' ? tr('hint_point') : tr('hint_profile');
    ae('feature_use', { slug: 'elevation', feature: 'mode_' + m });
  }

  /* Точка и профиль высот на светлой подложке: голубой #7fd1ff даёт на
     positron контраст 2.2, то есть отметка, ради которой сюда и приходят,
     почти растворяется. */
  var SKIN = { dark: { pin: '#7fd1ff', line: '#ff9c4a' }, light: { pin: '#0f5ea8', line: '#c2610a' } };
  var skin = 'dark';
  function initMap() {
    var host = $('elMap');
    if (!host || typeof L === 'undefined') return;
    Lf = L;
    state.map = Lf.map(host, { worldCopyJump: true, scrollWheelZoom: true })
      .setView([C.home.lat, C.home.lon], C.home.z || 9);
    // Подложка через общий примитив: два адреса и честная строка, если не
    // ответил ни один. Здесь стоял пустой `.on('tileerror', function () {})` —
    // карта чернела, а тул делал вид, что всё хорошо.
    var tile = C.tile || {};
    if (window.__mapTiles) {
      window.__mapTiles.base(Lf, state.map, null, {
        slug: 'elevation', credit: tr('map_attr'),
        styles: tile.styles, labels: tile.labels,
        onStyle: function (mode) {
          skin = SKIN[mode] ? mode : 'dark';
          var el = document.getElementById('elMap');
          if (el) el.setAttribute('data-basemap', mode);
          if (state.marker) { try { state.marker.setStyle({ color: SKIN[skin].pin, fillColor: SKIN[skin].pin }); } catch (e) {} }
          if (state.line) { try { state.line.setStyle({ color: SKIN[skin].line }); } catch (e) {} }
        },
        opts: { maxZoom: 17 },
        onExhausted: function () {
          var el = $('elMapOffline');
          if (!el) return;
          el.textContent = tr('map_offline');
          el.hidden = false;
        },
      });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(Lf, state.map, tr('map_attr'));
    }

    state.map.on('click', function (e) {
      if (state.mode === 'point') showPoint(e.latlng.lat, e.latlng.lng);
      else addProfilePoint(e.latlng.lat, e.latlng.lng);
    });
    showPoint(C.home.lat, C.home.lon);
  }

  function locate() {
    if (!navigator.geolocation) { if (window.__geo) window.__geo.notify('no_api'); return; }
    var b = $('elLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      if (b) b.disabled = false;
      var la = pos.coords.latitude, lo = pos.coords.longitude;
      state.map.setView([la, lo], 13);
      if (state.mode === 'point') showPoint(la, lo); else addProfilePoint(la, lo);
      // GPS сам даёт высоту — но по эллипсоиду и с большой ошибкой. Показываем
      // её отдельной строкой, а не вместо модели рельефа, и подписываем.
      if (pos.coords.altitude != null) {
        setText('elGps', fmt(pos.coords.altitude, 0) + ' ' + tr('m') +
          (pos.coords.altitudeAccuracy != null ? ' ±' + fmt(pos.coords.altitudeAccuracy, 0) : ''));
        var row = $('elGpsRow'); if (row) row.hidden = false;
      }
      ae('feature_use', { slug: 'elevation', feature: 'locate' });
    }, function (err) {
      if (b) b.disabled = false;
      if (window.__geo) window.__geo.notify(err);
    }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
  }

  function boot() {
    stage('load');
    initMap();
    var on = function (id, fn) { var el = $(id); if (el) el.addEventListener('click', fn); };
    on('elLocate', locate);
    on('elModePoint', function () { setMode('point'); });
    on('elModeProfile', function () { setMode('profile'); });
    on('elClear', clearProfile);
    setMode('point');
    stage('ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
